class CarouselCards extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.carousel = this.querySelector('[data-carousel]');
    this.controls = this.querySelectorAll('[data-prev], [data-next]');

    if (!this.carousel) return;

    this.flickity = new Flickity(this.carousel, {
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      freeScroll: true,
      // Without this every cell can be dragged to the left edge, so the last
      // card ends up alone with the rest of the row empty.
      contain: true,
    });
    this.controls.forEach((control) =>
      control.addEventListener('click', this.onControlClick.bind(this)),
    );

    ['scroll', 'settle', 'resize'].forEach((event) =>
      this.flickity.on(event, this.updateControls.bind(this)),
    );

    this.updateControls();
  }

  onControlClick(event) {
    const isNext = event.target.hasAttribute('data-next');

    if (!this.carousel) return;

    this.flickity[isNext ? 'next' : 'previous']();
  }

  // Nothing left to scroll towards means a dead button, so mirror the state of
  // the carousel on the arrows. Flickity contains the slide targets, so when
  // every card fits they all share one target and both arrows go disabled.
  updateControls() {
    const targets = this.flickity.slides.map((slide) => slide.target);

    if (!targets.length) return;

    const position = -this.flickity.x;
    const first = Math.min(...targets);
    const last = Math.max(...targets);

    this.controls.forEach((control) => {
      const isNext = control.hasAttribute('data-next');

      control.disabled = isNext ? position >= last - 1 : position <= first + 1;
    });
  }
}

customElements.define('carousel-cards', CarouselCards);
